var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Login',{ref:"login",on:{"showRegister":_vm.showRegister,"showPassword":_vm.showPassword}}),_c('Register',{ref:"register",on:{"showLogin":_vm.showLogin}}),_c('Password',{ref:"password",on:{"showLogin":_vm.showLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }